export const messages = {
  en: {
    couponPropertyPoolDetail: {
      search: {
        title: 'Search Conditions',
        cppId: 'Coupon ID',
        couponName: 'Coupon Name',
        fromType: 'Source Type',
        fromTypePlaceholder: 'Please select source type',
        fromType1: 'Purchased from coupon market',
        fromType2: 'Self-made',
        userName: 'User Name',
        tel: 'Phone Number',
        toType: 'Usage Type',
        toTypePlaceholder: 'Please select usage type',
        toType1: 'Shopping',
        toType2: 'Maintenance Coupon',
        toType3: 'Parking Coupon'
      },
      list: {
        title: 'Gift Records'
      },
      table: {
        cppId: 'ID',
        couponName: 'Coupon Name',
        value: 'Face Value',
        sendCount: 'Quantity',
        unit: 'piece',
        userName: 'User Name',
        tel: 'Phone Number',
        createTime: 'Gift Time'
      },
      btn: {
        return: 'Return'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to return this coupon?',
        success: 'Return successfully',
        error: 'Return failed'
      },
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    couponPropertyPoolDetail: {
      search: {
        title: '查询条件',
        cppId: '优惠券编号',
        couponName: '优惠券名称',
        fromType: '来源方式',
        fromTypePlaceholder: '请选择来源方式',
        fromType1: '优惠券市场购买',
        fromType2: '自己制作',
        userName: '用户名称',
        tel: '手机号',
        toType: '用途',
        toTypePlaceholder: '请选择用途',
        toType1: '购物',
        toType2: '维修券',
        toType3: '停车券'
      },
      list: {
        title: '赠送记录'
      },
      table: {
        cppId: '编号',
        couponName: '优惠券名称',
        value: '面值',
        sendCount: '数量',
        unit: '张',
        userName: '用户名称',
        tel: '手机号',
        createTime: '赠送时间'
      },
      btn: {
        return: '退回'
      },
      delete: {
        title: '确认操作',
        confirmText: '确定退回优惠券吗？',
        success: '退回成功',
        error: '退回失败'
      },
      fetchError: '获取数据失败'
    }
  }
}